import React from 'react';
import { User, AlertCircle } from 'lucide-react';
import EtudiantTableRow from './EtudiantTableRow';
import EtudiantPagination from './EtudiantPagination';

const EtudiantTable = ({
  etudiants,
  loading,
  erreur,
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  searchTerm,
  selectedClasse,
  selectedNiveau,
  selectedFiliere,
  onPageChange,
  onEdit,
  onCreateAccount
}) => {
  if (erreur) {
    return (
      <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4">
        <div className="flex">
          <AlertCircle className="h-5 w-5 text-red-400" />
          <div className="ml-3">
            <h3 className="text-sm font-medium text-red-800">Erreur</h3>
            <div className="mt-2 text-sm text-red-700">
              <p>{erreur}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#202654]"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Matricule
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Nom & Prénom
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Classe
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Contact
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          
          <tbody className="bg-white divide-y divide-gray-200">
            {etudiants.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-6 py-12">
                  <div className="flex flex-col items-center justify-center text-center">
                    <User className="h-12 w-12 text-gray-400 mb-4" />
                    <h3 className="text-lg font-medium text-gray-900 mb-1">Aucun étudiant trouvé</h3>
                    <p className="text-sm text-gray-500 max-w-md">
                      {searchTerm || selectedClasse || selectedNiveau || selectedFiliere ? 
                        'Essayez avec d\'autres critères de recherche' : 
                        'Aucun étudiant enregistré'}
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              etudiants.map((etudiant) => (
                <EtudiantTableRow
                  key={etudiant.id}
                  etudiant={etudiant}
                  onEdit={onEdit}
                  onCreateAccount={onCreateAccount}
                />
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <EtudiantPagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        pageSize={pageSize}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default EtudiantTable;
